import StorefrontIcon from '@mui/icons-material/Storefront';
import { Box, Grid } from '@mui/material';
import { IImageSqureCard } from './IImageSqureCard';
import { SmartImage } from '../../images/SmartImage';


export default function ImageSqureCard({
    data,
    onClick,
    stores,
    aspectRatio,
    maxHeight,
    maxWidth
}: IImageSqureCard) {
    return (
        <>
            <Grid
                className={'borderColorPrimaryColorLight-300 bg-[var(--input-bg-color)]'}
                style={{
                    borderRadius: '5px',
                    alignContent: 'center',
                    boxShadow: "0px 2px 4px rgba(0,0,0,0.16)",
                    paddingTop: "10px",
                    paddingBottom: "15px",
                    width: "100%",
                    height: "100%",
                    maxHeight: maxHeight != undefined ? maxHeight : "unset",
                    maxWidth: maxWidth != undefined ? maxWidth : "unset",
                    border: "1px solid var(--border-color)",
                }}
                sx={{
                    flex: {
                        xs: '1 1 calc(50% - 10px)',
                        md: '1 1 calc(30% - 10px)',
                    },
                    minHeight: { xs: "25vw", sm: "20vw", md: "15vw", lg: "10vw" },
                }}

                spacing={1}
                onClick={() => onClick!((data != undefined && data != null) ? data?.id : stores?.id)}
            >
                <Grid container gap={"5px"} width={"100%"} height={"100%"} flexDirection={"column"} xs={12} justifyContent={"center"} alignItems={"center"} flexWrap={'nowrap'} >
                    <Grid item width={'100%'} height={"75%"}>
                        <div style={{ position: "relative", width: "100%", height: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            {stores?.logoUrl ? (

                                <SmartImage src={`${stores?.logoUrl}`} alt={stores?.title || "logo"} imageStyle={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                }}
                                    size={100}
                                    borderRadius={5} />
                            ) : (
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                >
                                    <StorefrontIcon sx={{ color: "#D7DBEC", fontSize: "50px" }} />
                                </Box>
                            )}
                        </div>
                    </Grid>
                    <Grid item width={'100%'} height={"20%"} sx={{ textAlign: "center" }}>
                        <span style={{ fontSize: "12px", fontWeight: "bold" }} className="text-sm primaryColorLight-900">{(data != null && data != undefined ? data.title : stores?.title)}</span>
                    </Grid>

                </Grid>
            </Grid >
        </>
    );
}
